import { buildModelManager } from "../builder.js";
const DefaultAuthorTrendProfileSelection = {
  __typename: true,
  id: true,
  authorExternalKey: true,
  authorUserId: true,
  createdAt: true,
  errorState: true,
  institution: true,
  lastSourceRecordId: true,
  lastUpdatedFromSourceAt: true,
  profile: true,
  scopeId: true,
  scopeType: true,
  sourceSystem: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "authorTrendProfile";
const pluralModelApiIdentifier = "authorTrendProfiles";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAuthorTrendProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAuthorTrendProfileSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAuthorTrendProfileSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAuthorTrendProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAuthorTrendProfileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAuthorTrendProfileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAuthorTrendProfileSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAuthorTrendProfile",
    operationReturnType: "CreateAuthorTrendProfile",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      authorTrendProfile: { required: false, type: "CreateAuthorTrendProfileInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAuthorTrendProfileSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAuthorTrendProfiles",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAuthorTrendProfilesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAuthorTrendProfileSelection
  },
  {
    type: "action",
    operationName: "updateAuthorTrendProfile",
    operationReturnType: "UpdateAuthorTrendProfile",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      authorTrendProfile: { required: false, type: "UpdateAuthorTrendProfileInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAuthorTrendProfileSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAuthorTrendProfiles",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAuthorTrendProfilesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAuthorTrendProfileSelection
  },
  {
    type: "action",
    operationName: "deleteAuthorTrendProfile",
    operationReturnType: "DeleteAuthorTrendProfile",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAuthorTrendProfiles",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAuthorTrendProfile",
    operationReturnType: "UpsertAuthorTrendProfile",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      authorTrendProfile: { required: false, type: "UpsertAuthorTrendProfileInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAuthorTrendProfileResult": { hasReturnType: false },
      "... on UpdateAuthorTrendProfileResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAuthorTrendProfileSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAuthorTrendProfiles",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAuthorTrendProfilesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAuthorTrendProfileSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "authorTrendProfileGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AuthorTrendProfileManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAuthorTrendProfileSelection,
  operations
);
export {
  AuthorTrendProfileManager,
  DefaultAuthorTrendProfileSelection
};
//# sourceMappingURL=AuthorTrendProfile.js.map
